import * as React from "react";
import { Grid, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export default function AddButton({
  labelName,
  borderRadius,
  viewHeight,
  onClick,
  width,
  style,
  BtnAddIconCircleheight,
}) {
  return (
    <Grid
      sx={{
        borderRadius: borderRadius,
        height: viewHeight,
        cursor: "pointer",
        width: width,
        ...style,
      }}
      container
      alignItems={"center"}
      bgcolor={"#4c5a6a"}
      onClick={onClick}
    >
      <Grid
        sx={{
          width: {
            md: 20,
            xl: 23,
          },
          height: { md: 20, xl: 20 },
          background: "white",
          borderRadius: 50,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "10px",
        }}
      >
        <AddIcon sx={{ color: "black", width: "20px" }} />
      </Grid>
      <Typography
        sx={{
          color: "white",
          fontSize: { md: 10, xl: 14 },
          paddingLeft: "8px",
        }}
      >
        {labelName}
      </Typography>
    </Grid>
  );
}
